import React from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Select from "../../../../../common/StyledSelect";
import { Header, WithChatWindow } from "../../common";
import { compose } from "recompose"; 
import {
  Urgent as UrgentButton,
} from "./../../common/Buttons";

class EditCannedMessages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMsg: this.props.editMsg,
      value: "",
      errorInfo: "",
      isEditable: this.props.isEditable,
    };
  }

  componentDidUpdate(){
    if(this.props.editMsg.type === "select" && this.state.value && !this.props.pendingCustomers.includes(this.state.value)){
      this.setState({
        value:""
      })
    }
  }

  sendEditMessage = () => {
    if (this.state.value) {
      const editedMessage = this.state.editMsg.text.replace(
        "________",
        `${this.state.value} `
      );
      this.props.onMessageSubmit({message: editedMessage, isUrgent: this.props.isUrgent});
      this.setState({
        value: "",
        editMsg: "",
        isEditable: false,
        errorInfo: "",
      });
    } else {
      this.setState({ errorInfo: "*This Field is required" });
    }
  };
  handleChange = (event) => {
    this.setState({
      value: event.target.value,
      errorInfo: "",
    });
  };

  handleSelectChange = (event) => {
      this.setState({
        value: event?.value ?? '',
        errorInfo: "",
      });
  };

  cancelEditMessage = () => {
    this.setState({ editMsg: "", isEditable: false, value: "", errorInfo: "" });
    this.props.cancelEditMessage();
  };

  skipNonNumericInput = (e) => {
    ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
  };

  render() {
    const { classes,pendingCustomers, isUrgent, toggleUrgent } = this.props;
    const { editMsg } = this.state;

    const pendingCustomersOptions =  pendingCustomers.map(name => ({label:name, value: name}))
    return (
      <>
        
        <Header title="Edit Message">
            <UrgentButton isMarkedAsUrgent={isUrgent} onClick={toggleUrgent}/>
        </Header>
        <div className={`${classes.editCannedMessageContainer} customScroll`}>
          <div className={classes.listItemText}>{editMsg.text}</div>
          {editMsg.type !== "none" && editMsg.type === "select" ? (
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "customer",
                  label: "",
                  variant: "outlined",
                  helperText: this.state.errorInfo,
                }}
                value={this.state.value}
                onChange={this.handleSelectChange}
                error={Boolean(this.state.errorInfo)}
                data={pendingCustomersOptions}
              />
            </div>
          ) : (
            <TextField
              id="number"
              type="number"
              label=""
              InputProps={{ inputProps: { min: 0, max: 100 } }}
              value={this.state.value}
              onChange={this.handleChange}
              variant="outlined"
              autoComplete="off"
              error={Boolean(this.state.errorInfo)}
              helperText={this.state.errorInfo}
              onKeyDown={this.skipNonNumericInput}
            />
          )}
          <div>
            <Button onClick={this.cancelEditMessage} color="secondary">
              Cancel
            </Button>
            <Button color="primary" onClick={this.sendEditMessage}>
              Send
            </Button>
          </div>
        </div>
      </>
    );
  }
}

export default compose(WithChatWindow)(EditCannedMessages);
